/* global axios */

import ApiClient from './ApiClient';

class PermissionGroups extends ApiClient {
  constructor() {
    super('permission_groups', { accountScoped: true });
  }

  getAvailablePermissions() {
    return axios.get(`${this.url}/available_permissions`);
  }
}

export default new PermissionGroups();
